__turbopack_context__.v({
  "container": "sFT-qW_container",
  "fakePaperTop": "sFT-qW_fakePaperTop",
  "lowerContainer": "sFT-qW_lowerContainer",
  "tabbedView": "sFT-qW_tabbedView",
});
